/**
 * Width (in rhythms) of the main part
 */
export const mainAreaWidth = 40
/**
 * Width (in rhythms) of side bars
 */
export const sideBarWidth = 12